module.exports = __webpack_public_path__ + "img/check-red.6a235a15.svg";